import type { ElementProps } from 'lib/element.js'

import type { SupportedDeviceTableManufacturerKeysProps } from './SupportedDeviceTableManufacturerKeys.js'

export const name = 'seam-supported-device-table-manufacturer-keys'

export const props: ElementProps<SupportedDeviceTableManufacturerKeysProps> = {}

export { SupportedDeviceTableManufacturerKeys as Component } from './SupportedDeviceTableManufacturerKeys.js'
